module.exports = __webpack_public_path__ + "img/img20.9b6f85b7.svg";